export default __webpack_public_path__ + "static/media/ic_icon_worldmap.5a8dcd3e.svg";